import { showToast } from "../../helpers/toasts";

const balancerToastsMixin = {
    methods: {
        showDeleteBalancerEquipmentToast(name) {
            const deleteToastTitle = this.$t('toasts.balancer.equipments.delete.title');

            const deleteToastDetails = `
                    ${this.$t(`toasts.balancer.equipments.delete.details1`)}
                    ${name}
                    ${this.$t(`toasts.balancer.equipments.delete.details2`)}`
            ;

            showToast('success',
                deleteToastTitle,
                deleteToastDetails
            );
        },

        showCreateBalancerEquipmentToast() {
            showToast('success',
                this.$t('toasts.success'),
                this.$t('toasts.balancer.equipments.create.details')
            );
        },

        showDeleteBalancerStationToast(name) {
            const deleteToastTitle = this.$t('toasts.balancer.stations.delete.title');

            const deleteToastDetails = `
                    ${this.$t(`toasts.balancer.stations.delete.details1`)}
                    ${name}
                    ${this.$t(`toasts.balancer.stations.delete.details2`)}`
            ;

            showToast('success',
                deleteToastTitle,
                deleteToastDetails
            );
        },

        showCreateBalancerStationToast() {
            showToast('success',
                this.$t('toasts.success'),
                this.$t('toasts.balancer.stations.create.details')
            );
        }
    }
}

export {
    balancerToastsMixin
}